import { getUndergroundCasinoGames } from '@/api/UndergroundCasino';

export default {
  syncUndergroundCasinoGames(_: any, operatorId: number): Promise<void> {
    return getUndergroundCasinoGames(operatorId);
  }
};
